import { AvatarConsts } from 'Common/UserAvatar/Avatar/Avatar.consts';

export const getUserDisplayName = (name: string | null | undefined) =>
  name ?? AvatarConsts.fallbackUserName;
